import script from "./CurrentClinicSection.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentClinicSection.vue?vue&type=script&setup=true&lang=js"

import "./CurrentClinicSection.vue?vue&type=style&index=0&id=b7180a64&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7180a64"]])

export default __exports__